export class DashboardSummary {
    Caption: string
    DashboardCount: number
    OrderBy:number
    
    TotalCount: number;
    ReportId:number;
    constructor() {
        this.Caption = "";
        this.DashboardCount = 0;
        this.OrderBy=0;
      
        this.TotalCount=0;
        this.ReportId=0;
    }
}